import { render, staticRenderFns } from "./SciencePage.vue?vue&type=template&id=b249bdb0&scoped=true&"
import script from "./SciencePage.vue?vue&type=script&lang=js&"
export * from "./SciencePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b249bdb0",
  null
  
)

export default component.exports